<dx-popup #dlgSaleItemEditor [width]="600" [height]="400" [showTitle]="true" title="Sell Voucher" [resizeEnabled]=true
    [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OkButtonOptions">
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <dx-form [showColonAfterLabel]="false" colCount="1" [formData]="saleItemDetail" colCount="2"
            (onFieldDataChanged)="onFieldDataChanged($event)">
            <dxi-item itemType="simple" colSpan="2" dataField="TypeDesc" [editorOptions]="{disabled:true}">
                <dxo-label text="Type"></dxo-label>
            </dxi-item>
            <dxi-item itemType="simple" colSpan="2" dataField="Description" [editorOptions]="{disabled:true}">
                <dxo-label text="Description"></dxo-label>
            </dxi-item>
            <dxi-item dataField="Price" editorType="dxNumberBox" [editorOptions]="PriceEditorOptions">
                <dxo-label text="Retail Price"></dxo-label>
            </dxi-item>
            <dxi-item dataField="CashValue" editorType="dxNumberBox" [editorOptions]="PriceEditorOptions">
                <dxo-label text="Cash Value"></dxo-label>
            </dxi-item>
            <dxi-item dataField="VoucherCode" [colSpan]="2" [editorOptions]="VoucherCodeEditorOptions">
                <dxo-label text="Voucher Code"></dxo-label>
                <dxi-validation-rule type="required" message="Voucher Code is required">
                </dxi-validation-rule>
                <dxi-validation-rule type="pattern" [pattern]="Constants.VoucherCodePattern" reevaluate="true"
                    [message]="Constants.VoucherCodeMessage">
                </dxi-validation-rule>
                <dxi-validation-rule type="async" [message]="Constants.UniqueVoucherValidationMessage"
                    [validationCallback]="VoucherCodeValidation">
                </dxi-validation-rule>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>